import React, { useState, useEffect, useRef } from 'react';
import './ImportedWaffle.css';
import { getBaseUrl } from '../config/waffle.config';

/**
 * ImportedWaffle component that creates a local version of the waffle menu
 * based on the 3E Online app strip.
 */
const ImportedWaffle: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const waffleRef = useRef<HTMLDivElement>(null);
  const baseUrl = getBaseUrl();

  // Toggle the menu open/closed
  const toggleMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsMenuOpen(!isMenuOpen);
  };

  // Close the menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (waffleRef.current && !waffleRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div id="appStrip" ref={waffleRef}>
        <ul id="menu" className="app-grid-menu">
            <li>
                <div>
                    <a href="#" onClick={toggleMenu}>
                        <img
                          style={{ margin: '0 10px' }}
                          src={`${baseUrl}/Content/images/Waffle.svg`}
                          width="16"
                          height="16"
                          alt="App Menu"
                        />
                    </a>
                </div>
                <ul id="sub-menu" style={{ display: isMenuOpen ? 'block' : 'none', zIndex: 1000 }}>
                    <li className="app-grid">
                        {/* First Row */}
                        <a href={`${baseUrl}/eeeonlineportal`} target="_blank" rel="noopener noreferrer">
                            <div className="appBack">
                                <img className="appIcon" src={`${baseUrl}/Content/images/3eProtectIconWaffle.svg`} alt="3E Protect" />
                            </div>
                        </a>
                        <a href={`${baseUrl}/webinsight`} target="_blank" rel="noopener noreferrer">
                            <div className="appBack">
                                <img className="appIcon" src={`${baseUrl}/Content/images/3eInsightChemicalsIconWaffle.svg`} alt="3E Insight Chemicals" />
                            </div>
                        </a>

                        {/* Second Row */}
                        <a href={`${baseUrl}/notify`} target="_blank" rel="noopener noreferrer">
                            <div className="appBack">
                                <img className="appIcon" src={`${baseUrl}/Content/images/3eNotifyIconWaffle.svg`} alt="3E Notify" />
                            </div>
                        </a>
                        <a href={`${baseUrl}/ariellogic`} target="_blank" rel="noopener noreferrer">
                            <div className="appBack">
                                <img className="appIcon" src={`${baseUrl}/Content/images/3eInsightFoodIconWaffle.svg`} alt="3E Insight Food" />
                            </div>
                        </a>

                        {/* Third Row */}
                        <a href={`${baseUrl}/exchange`} target="_blank" rel="noopener noreferrer">
                            <div className="appBack">
                                <img className="appIcon" src={`${baseUrl}/Content/images/3eExchangeIconWaffle.svg`} alt="3E Exchange" />
                            </div>
                        </a>
                        <a href={`${baseUrl}/msdgen`} target="_blank" rel="noopener noreferrer">
                            <div className="appBack">
                                <img className="appIcon" src={`${baseUrl}/Content/images/3eGenerateIconWaffle.svg`} alt="3E Generate" />
                            </div>
                        </a>

                        {/* Fourth Row */}
                        <a href={`${baseUrl}/eeeonlineportal/msdgenonrequest`} target="_blank" rel="noopener noreferrer">
                            <div className="appBack">
                                <img className="appIcon" src={`${baseUrl}/Content/images/3eGenerateOnRequestIconWaffle.svg`} alt="3E Generate On Request" />
                            </div>
                        </a>
                        <a href={`${baseUrl}/3eoptimize`} target="_blank" rel="noopener noreferrer">
                            <div className="appBack">
                                <img className="appIcon" src={`${baseUrl}/Content/images/3eOptimizeIconWaffle.svg`} alt="3E Optimize" />
                            </div>
                        </a>

                        {/* Back to 3EiQ option */}
                        <a href={baseUrl} className="back-to-3eiq" target="_blank" rel="noopener noreferrer">
                            <p className="light-blue">Back to 3EOnline.com</p>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
  );
};

export default ImportedWaffle;